export const computer = {
  title: '电脑数码',
  id: '36',
  link: ['手机', '手机配件', '数码配件', '影音娱乐'],
  detail: [
    {
      bigImg: 'static/img/index/computer/item-computer-1.jpg',
      itemFour: [
        {
          title: '蓝牙音箱',
          intro: '轻松连接',
          secCata: '45',
          img: 'static/img/index/computer/item-computer-2.jpg'
        },
        {
          title: 'U盘',
          intro: '潮物新品',
          secCata: '44',
          img: 'static/img/index/computer/item-computer-1-3.jpg'
        },
        {
          title: '电脑配件',
          intro: '轻松办公',
          secCata: '44',
          img: 'static/img/index/computer/item-computer-1-4.jpg'
        },
        {
          title: '专业音频',
          intro: '尖货新品',
          secCata: '45',
          img: 'static/img/index/computer/item-computer-1-5.jpg'
        }
      ],
      itemContent: [
        'static/img/index/computer/item-computer-1-6.jpg',
        'static/img/index/computer/item-computer-1-7.jpg',
        'static/img/index/computer/item-computer-1-8.jpg'
      ]
    },
    {
      bigImg: 'static/img/index/computer/item-computer-2-1.jpg',
      itemFour: [
        {
          title: '手机好店',
          intro: '专选好货',
          secCata: '42',
          img: 'static/img/index/computer/item-computer-2-2.jpg'
        },
        {
          title: '配件专区',
          intro: '精致小巧',
          secCata: '43',
          img: 'static/img/index/computer/item-computer-2-3.jpg'
        },
        {
          title: '手机配件',
          intro: '方便实用',
          secCata: '45',
          img: 'static/img/index/computer/item-computer-2-4.jpg'
        },
        {
          title: '智能手机',
          intro: '人气新品',
          secCata: '42',
          img: 'static/img/index/computer/item-computer-2-5.jpg'
        }
      ],
      itemContent: [
        'static/img/index/computer/item-computer-2-6.jpg',
        'static/img/index/computer/item-computer-2-7.jpg',
        'static/img/index/computer/item-computer-2-8.jpg'
      ]
    }
  ]
};

export const daily = {
  title: '日用百货',
  link: [ '厨具', '收纳', '清洁' ],
  id: '35',
  detail: [
    {
      bigImg: 'static/img/index/eat/item-eat-3-8.webp',
      itemFour: [
        {
          title: '清洁用品',
          intro: '品质生活',
          secCata: '41',
          img: 'static/img/classification/daily-qjyp.jpeg'
        },
        {
          title: '烘焙厨具',
          intro: '厨房好帮手',
          secCata: '39',
          img: 'static/img/classification/daily-hbcj.jpeg'
        },
        {
          title: '垃圾收纳',
          intro: '整洁有序',
          secCata: '40',
          img: 'static/img/classification/daily-ljsn.jpeg'
        },
        {
          title: '厨具',
          intro: '热爱生活\n美食美味',
          secCata: '39',
          img: 'static/img/classification/daily-cj.jpeg'
        }
      ],
      itemContent: [
        'static/img/index/eat/item-eat-3-1.jpg',
        'static/img/index/eat/item-eat-3-2.jpg',
        'static/img/index/eat/item-eat-3-3.jpg'
      ]
    },
    {
      bigImg: 'static/img/index/eat/item-eat-3-9.webp',
      itemFour: [
        {
          title: '保温又保冷',
          intro: '随身携带\n方便环保',
          secCata: '39',
          img: 'static/img/classification/daily-bwbl.jpeg'
        },
        {
          title: '毛巾',
          intro: '柔软贴身\n细心呵护',
          secCata: '39',
          img: 'static/img/classification/daily-mj.jpeg'
        },
        {
          title: '家居清洁',
          intro: '清爽干净',
          secCata: '41',
          img: 'static/img/classification/daily-jjqj.jpeg'
        },
        {
          title: '烘焙厨具',
          intro: '美味好生活',
          secCata: '39',
          img: 'static/img/classification/daily-hbcj.jpeg'
        }
      ],
      itemContent: [
        'static/img/index/eat/item-eat-3-4.jpeg',
        'static/img/index/eat/item-eat-3-5.jpeg',
        'static/img/index/eat/item-eat-3-6.jpeg'
      ]
    }
  ]
};

export const office = {
  title: '办公用品',
  id: '37',
  link: [ '笔记本', '笔', '文具收纳', '书法画材' ],
  detail: [
    {
      bigImg: 'static/img/index/office/office-18.jpg',
      itemFour: [
        {
          title: '美术益智',
          intro: '办公学习',
          secCata: '47',
          img: 'static/img/classification/office-msyz.jpeg'
        },
        {
          title: '桌面办公',
          intro: '资料分类\n轻松办公',
          secCata: '48',
          img: 'static/img/classification/office-zmbg.jpeg'
        },
        {
          title: '一站式办公采购',
          intro: '办公选货超市',
          secCata: '48',
          img: 'static/img/index/office/office-4.jpg'
        },
        {
          title: '办公收纳',
          intro: '专业定制\n用品分类',
          secCata: '48',
          img: 'static/img/classification/office-bgsn.jpeg'
        }
      ],
      itemContent: [
        'static/img/index/office/office-12.jpg',
        'static/img/index/office/office-13.jpg',
        'static/img/index/office/office-14.jpg'
      ]
    },
    {
      bigImg: 'static/img/index/office/office-19.jpg',
      itemFour: [
        {
          title: '本册便签',
          intro: '环保材质',
          secCata: '46',
          img: 'static/img/classification/office-bcbq.jpeg'
        },
        {
          title: '书写工具',
          intro: '轻松书写',
          secCata: '47',
          img: 'static/img/classification/office-sxgj.jpeg'
        },
        {
          title: '文件管理',
          intro: '档案整理',
          secCata: '48',
          img: 'static/img/classification/office-wjgl.jpeg'
        },
        {
          title: '文件收纳',
          intro: '加厚大容量',
          secCata: '48',
          img: 'static/img/classification/office-wjsn.jpeg'
        }
      ],
      itemContent: [
        'static/img/index/office/office-15.png',
        'static/img/index/office/office-16.gif',
        'static/img/index/office/office-14.jpg'
      ]
    }
  ]
};

export const electrical = {
  title: '家用电器',
  id: '38',
  link: [ '个护电器', '厨房电器', '生活电器', '大家电' ],
  detail: [
    {
      bigImg: 'static/img/index/electrical/electrical-12.jpg',
      itemFour: [
        {
          title: '厨房电器',
          intro: '美味来自这里',
          secCata: '50',
          img: 'static/img/classification/electrical-cfdq.jpeg'
        },
        {
          title: '生活电器',
          intro: '居家好电器',
          secCata: '51',
          img: 'static/img/classification/electrical-shdq.jpeg'
        },
        {
          title: '厨房电器',
          intro: '健康新生活',
          secCata: '50',
          img: 'static/img/classification/electrical-cfdq2.jpeg'
        },
        {
          title: '生活电器',
          intro: '精品好电器',
          secCata: '51',
          img: 'static/img/classification/electrical-ghdq.jpeg'
        }
      ],
      itemContent: [
        'static/img/index/electrical/electrical-9.jpg',
        'static/img/index/electrical/electrical-10.png',
        'static/img/index/electrical/electrical-11.png'
      ]
    },
    {
      bigImg: 'static/img/index/electrical/electrical-13.jpg',
      itemFour: [
        {
          title: '厨房电器',
          intro: '价格优惠',
          secCata: '50',
          img: 'static/img/classification/electrical-cfdq3.jpeg'
        },
        {
          title: '生活电器',
          intro: '生活小资',
          secCata: '51',
          img: 'static/img/classification/electrical-shdq2.jpeg'
        },
        {
          title: '大家电',
          intro: '厨房新主张',
          secCata: '52',
          img: 'static/img/classification/electrical-cfdq4.jpeg'
        },
        {
          title: '个护电器',
          intro: '享受精彩',
          secCata: '49',
          img: 'static/img/classification/electrical-shdq3.jpeg'
        }
      ],
      itemContent: [
        'static/img/index/electrical/electrical-14.jpg',
        'static/img/index/electrical/electrical-15.jpg',
        'static/img/index/electrical/electrical-14.jpg'
      ]
    }
  ]
};

// 秒杀
export const seckill = [
  {
    id: 68,
    intro: '小米米家体重秤体脂秤',
    img: 'static/img/index/electrical/electrical-5.jpg',
    price: 120,
    realPrice: 130,
    cataid: '49',
    firCata: '38'
  },
  {
    id: 70,
    intro: '红双喜空气循环扇静音遥控电风扇',
    img: 'static/img/index/electrical/electrical-1.jpg',
    price: 188,
    realPrice: 299.0,
    cataid: '51',
    firCata: '38'
  },
  {
    id: 57,
    intro: '马利牌彩色铅笔套装48色水溶性彩铅画笔',
    img: 'static/img/index/office/office-8.jpg',
    price: 185,
    realPrice: 199,
    cataid: '48',
    firCata: '37'
  },
  {
    id: 53,
    intro: '电脑音响台式家用多媒体低音炮',
    img: 'static/img/index/computer/item-computer-5.jpeg',
    price: 98,
    realPrice: 99.9,
    cataid: '44',
    firCata: '36'
  },
  {
    id: 42,
    intro: '小型厨房秤',
    img: 'static/img/index/eat/item-eat-1-3.jpg',
    price: 42,
    realPrice: 49,
    cataid: '40',
    firCata: '35'
  }
];

// 距离开始秒杀时间
export const deadline = {
  hours: 1,
  minute: 38,
  seconds: 36
};

export const carousel = {
  carouselItems: [
    {
      url: 'static/img/nav/1.jpg',
      cata: '35'
    },
    {
      url: 'static/img/nav/2.jpg',
      cata: '36'
    },
    {
      url: 'static/img/nav/3.jpg',
      cata: '37'
    },
    {
      url: 'static/img/nav/4.jpg',
      cata: '38'
    }
  ],
  activity: [
    {
      url: 'static/img/nav/nav_showimg1.png',
      cata: '36'
    },
    {
      url: 'static/img/nav/nav_showimg2.webp',
      cata: '38'
    }
  ]
};

export const recommend = [
  [
    {
      img: 'static/img/otherBuy/1.jpg',
      intro: 'iPhone7/6s/8钢化膜苹果7Plus全屏全覆盖3D抗蓝',
      price: 29.00
    },
    {
      img: 'static/img/otherBuy/2.jpg',
      intro: '苹果数据线 苹果iPhoneX/6s/7plus/8充电线',
      price: 36.00
    },
    {
      img: 'static/img/otherBuy/3.jpg',
      intro: '苹果8/7/6/6s钢化膜 iphone8/7/6s/6钢化玻璃',
      price: 19.00
    },
    {
      img: 'static/img/otherBuy/4.jpg',
      intro: 'iPhone6s/7钢化膜苹果8 人气新品',
      price: 28.00
    }
  ],
  [
    {
      img: 'static/img/otherBuy/5.jpg',
      intro: '苹果6s手机壳iPhone6s Plus保护壳防摔全',
      price: 28.00
    },
    {
      img: 'static/img/otherBuy/6.jpg',
      intro: 'iPhone7/8手机壳手机套防摔磨砂保护壳星空黑☆全包保护',
      price: 30.00
    },
    {
      img: 'static/img/otherBuy/7.jpg',
      intro: '数据线 适用于苹果iPhone 6s/6plus/7plus/8/X',
      price: 18.00
    },
    {
      img: 'static/img/otherBuy/8.jpg',
      intro: 'iPhone8/7/6S/6钢化膜 苹果8/7/6s/6玻璃膜 手机高',
      price: 15.00
    }
  ]
];



// WEBPACK FOOTER //
// ./src/vuex/mock.js